import {useEffect} from 'react';
import {setAppSpecificTags, type Tags} from '~library/utils/evite/tagging';

export const useAppTagging = (tags: Tags) => {
  useEffect(() => {
    setAppSpecificTags(tags);
  }, [tags]);
};
